import { Injectable } from "@angular/core";
import { IFilter, IQuestionnaireResponse, ITPDAInfos, ITPDAParticipant } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { ApiService } from "src/app/providers/api/api.service";
import { BaseApiService } from "src/app/providers/api/baseApi.service";

@Injectable({
  providedIn: "root",
})
export class TPDAsApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "TPDAs", // Theme !
      ["dashboard/TPDA/invite"], // Post route paths
      [
        "dashboard/TPDAInfos", // 0
        "dashboard/nbTPDAInfos", // 1
        "dashboard/TPDA/questionnaireResponse", // 2
        "dashboard/TPDA/participant", // 3
        "dashboard/TPDA/consentform", // 4
        "dashboard/TPDA/QRsPDF", // 5
      ], // Get route paths
      [], // Update route paths
      [] // Delete route paths
    );
  }

  public getTPDAInfos(
    lang: string,
    pageNumber: number,
    pageSize: number,
    search?: string,
    sortId?: string,
    sortOrder?: string,
    filters?: string,
    servicesIds?: string
  ): Observable<ITPDAInfos[]> {
    const params = { lang, pageNumber, pageSize, search, sortId, sortOrder, filters, servicesIds };
    return this.api.get(this.readRoutes[0], params) as Observable<ITPDAInfos[]>;
  }

  public getNbTPDAInfos(lang: string, search?: string, filters?: IFilter[], servicesIds?: string): Observable<number> {
    const params = { lang, search, filters: JSON.stringify(filters), servicesIds };
    return this.api.get(this.readRoutes[1], params) as Observable<number>;
  }

  public getTPDAQRs(TPDAId: string, idParticipant?: string): Observable<IQuestionnaireResponse[]> {
    const params = { TPDAId };
    const URL = this.readRoutes[2] + (idParticipant ? "/" + idParticipant : "");
    return this.api.get(URL, params) as Observable<IQuestionnaireResponse[]>;
  }

  public getTPDAParticipants(TPDAId: string, idParticipant?: string): Observable<ITPDAParticipant[]> {
    const params = { TPDAId };
    const URL = this.readRoutes[3] + (idParticipant ? "/" + idParticipant : "");
    return this.api.get(URL, params) as Observable<ITPDAParticipant[]>;
  }
  public getTPDAConsentFormsPDFs(TPDAId: string, idParticipant?: string): Observable<Blob> {
    const params = { TPDAId };
    const URL = this.readRoutes[4] + (idParticipant ? "/" + idParticipant : "");
    return this.api.getBlob(URL, params) as Observable<Blob>;
  }
  public getTPDAQRsPDFs(TPDAId: string, idParticipant?: string, qrId?: string): Observable<Blob> {
    const params = { TPDAId, qrId };
    const URL = this.readRoutes[5] + (idParticipant ? "/" + idParticipant : "");
    return this.api.getBlob(URL, params) as Observable<Blob>;
  }

  public sendTPDAInvitations(TPDAId: string, emails: string[], lang: string): Observable<string[]> {
    const body = {
      TPDAId,
      emails,
      lang,
    };
    return this.api.post(this.createRoutes[0], body) as Observable<string[]>;
  }
}
